/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { getCookie } from "../utils/cookieUtils";

const documentTemplatesApiBaseUrl = import.meta.env.VITE_DOCUMENT_TEMPLATES_API;

const documentTemplatesApi = axios.create({
  baseURL: documentTemplatesApiBaseUrl,
});

documentTemplatesApi.interceptors.request.use((config) => {
  const token = getCookie("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// --- DTOs ---

export interface Position {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface SignatureLocation {
  page: number;
  position: Position;
}

export interface TextInterpolation {
  page: number;
  x: number;
  y: number;
  size: number;
  font: string;
  color: string;
}

export interface DocumentTemplate {
  id: string;
  name: string;
  s3_key: string;
  verified: boolean;
  created_at: string;
  updated_at: string;
  signature_locations: Record<string, SignatureLocation>;
  text_interpolations: Record<string, TextInterpolation>;
}

export interface ListDocumentTemplatesResponse {
  document_templates: DocumentTemplate[];
  next_page_token?: string;
}

export interface DownloadResponse {
  message: string;
  download_url: string;
}

export interface VerifyResponse {
  message: string;
}

// --- API Methods ---

export const getDocumentTemplate = async (
  id: string
): Promise<DocumentTemplate> => {
  const response = await documentTemplatesApi.get<DocumentTemplate>(
    "/api/document-template",
    { params: { id } }
  );
  return response.data;
};

export const listDocumentTemplates = async (
  limit = 10,
  startAfter?: string,
  name?: string
): Promise<ListDocumentTemplatesResponse> => {
  const params: any = { limit };
  if (startAfter) params.start_after = startAfter;
  if (name) params.name = name;

  const response =
    await documentTemplatesApi.get<ListDocumentTemplatesResponse>(
      "/api/document-templates",
      { params }
    );
  return response.data;
};

export const downloadDocumentTemplate = async (
  id: string
): Promise<DownloadResponse> => {
  const response = await documentTemplatesApi.get<DownloadResponse>(
    "/api/document-template/download",
    { params: { id } }
  );
  return response.data;
};
